module.exports = __webpack_public_path__ + "static/media/venetian08.271f68fc.png";